import { objectSpread2 as _objectSpread2, slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';

var lastSuccessfulEndpointKey = 'failoverClient.lastSuccessfulEndpoint';
var errorStatuses = [401, 502, 503];
var defaultFailoverPolicy = function defaultFailoverPolicy(e) {
  if (e.graphQLErrors && e.graphQLErrors.length) {
    var _e$graphQLErrors = _slicedToArray(e.graphQLErrors, 1),
      data = _e$graphQLErrors[0].data;
    return data && data.status === 503;
  }
  return e.networkError && errorStatuses.includes(e.networkError.statusCode);
};
var saveEndpoint = function saveEndpoint(endPoint) {
  localStorage.setItem(lastSuccessfulEndpointKey, endPoint);
};
var failover = function failover(configuration) {
  var lastSuccessfulEndpoint = localStorage.getItem(lastSuccessfulEndpointKey) || '';
  var currentInstance = configuration.map(function (i) {
    return i.path;
  }).indexOf(lastSuccessfulEndpoint) !== -1 ? configuration.map(function (i) {
    return i.path;
  }).indexOf(lastSuccessfulEndpoint) : 0;
  saveEndpoint(configuration[currentInstance].path);
  var getCurrentInstance = function getCurrentInstance() {
    return configuration[currentInstance];
  };
  var switchServer = function switchServer() {
    currentInstance = currentInstance + 1 > configuration.length - 1 ? 0 : currentInstance + 1;
    saveEndpoint(configuration[currentInstance].path);
  };
  var withFailover = function withFailover(failable) {
    var failoverPolicy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFailoverPolicy;
    var numberOfRetries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : configuration.length - 1;
    return function (context) {
      var currentPath = getCurrentInstance().path;
      return failable(_objectSpread2(_objectSpread2({}, context), {}, {
        instance: getCurrentInstance().client,
        url: getCurrentInstance().path
      }))["catch"](function (err) {
        if (!failoverPolicy(err)) {
          return Promise.reject(err);
        }
        if (numberOfRetries < 1) {
          throw err;
        }
        if (currentPath === getCurrentInstance().path) {
          switchServer();
        }
        return withFailover(failable, failoverPolicy, numberOfRetries - 1)(context);
      });
    };
  };
  return withFailover;
};

export { failover };
